import React from 'react';
import Nav from '../../nav';

export const Default = () => (
  <Nav />
);



// WEBPACK FOOTER //
// ./src/components/layout/header/index.js